const { useI18n } = require('nordic/i18n');
const { Card } = require('@andes/card');
const { List, ListItem } = require('@andes/list');
const { Thumbnail } = require('@andes/thumbnail');
const { Typography } = require('@andes/typography');

const translate = require('../../../translation');
const { generateIcon } = require('../../../utils/icons');

const ShippingActions = ({
  delivery,
  isMobile,
  handleShippingOptions,
  handleShippingAddress,
  rebranding,
}) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const contact =
    delivery?.address?.contact !== '' &&
    delivery?.address?.contact.split(' - ');

  const actionList = [
    {
      rule: true,
      title: delivery?.arrival,
      description: '',
      icon: 'icon_pin',
      handleEvent: () => handleShippingOptions(),
      className: rebranding ? 'shipping-rebrand-color' : 'shipping-icon',
    },
    {
      rule: true,
      title: delivery?.address?.street,
      description: delivery?.address?.details,
      icon: 'icon_shipping_type',
      handleEvent: () => handleShippingAddress(),
      className: rebranding ? 'shipping-rebrand-color' : 'shipping-icon',
    },
    {
      rule: delivery?.address?.contact !== '',
      title: contact?.[0],
      description: `${contact?.[1]} - ${contact?.[2]}`,
      icon: 'icon_user_shipping_review',
      handleEvent: () => handleShippingAddress(),
      className: rebranding ? 'shipping-rebrand-color' : 'shipping-icon',
    },
  ];

  return (
    <section className="shipping-generics shipping-review">
      <Card className="mt-16 mb-16" shadow={isMobile ? 'elevated' : undefined}>
        <List className="desktop-card" withDividers>
          {actionList.map(
            ({ title, icon, description, rule, handleEvent }) =>
              rule && (
                <ListItem
                  key={title}
                  title={
                    <div className="d-flex d-flex-column">
                      <Typography type="body" size="m">
                        {title}
                      </Typography>
                      <Typography type="body" color="secondary" size="s">
                        {description}
                      </Typography>
                    </div>
                  }
                  rightContentPosition="top"
                  leftContent={
                    <Thumbnail size="40" srLabel="icon_user">
                      {generateIcon({ type: icon })}
                    </Thumbnail>
                  }
                  rightContent={
                    <span className="modify-action">{translations.MODIFY}</span>
                  }
                  onClick={handleEvent}
                />
              ),
          )}
        </List>
      </Card>
    </section>
  );
};

module.exports = { ShippingActions };
